<template>
  <v-dialog 
    v-model="dialog" 
    persistent
    max-width="1000px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        color="hrissecondary"
        class="white--text px-10 mx-1"
        v-on="on"
      >
        Rehire
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Rehire"
      text="Employee Rehire"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-stepper v-model="step">
          <v-stepper-header>
            <template v-for="(stepperHeader,i) in stepperHeaders">
              <v-stepper-step
                :key="`${i}-key`"
                :step="i+1"
                :complete="i+1 < step"
              >
                {{ stepperHeader.name }}
              </v-stepper-step>
              <v-divider
                v-if="i !== stepperHeaders"
                :key="i"
              />
            </template>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <employee-profile-job-rehire-employment-details
                ref="employmentDetail"
                :employee-uid="employeeUid"
                :rehire-min-date="rehireMinDate"
                @close-dialog="closeDialog"
                @next-step="nextStep"
              />
            </v-stepper-content>

            <v-stepper-content step="2">
              <employee-profile-job-rehire-workdays
                ref="workday"
                @previous-step="previousStep"
                @submit-form="submitForm"
              />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      EmployeeProfileJobRehireEmploymentDetails: () => import('@/components/hris/employee/profile/job/rehire/EmploymentDetails'),
      EmployeeProfileJobRehireWorkdays: () => import('@/components/hris/employee/profile/job/rehire/Workdays'),
    },
    props: {
      employeeUid: {
        type: String,
        default: '',
      },
      rehireMinDate: {
        type: String, 
        default: '',
      },
    },
    data () {
      return {
        step: 1,
        stepperHeaders: [
          { 'name': 'Employment Details' },
          { 'name': 'Workdays' },
        ],
        dialog: false,
        // progressing: false,
        loading: false, 
      }
    },

    watch: {
      dialog: function (val) {
        if (!val) return this.$resetData()

        this.step = 1
      },
    },
    methods: {
      closeDialog () {
        this.dialog = false
      },
      nextStep () {
        this.step += 1
      },
      previousStep () {
        this.step -= 1
      },

      submitForm () {
        this.$refs.workday.loadingTrue()

        this.$api.rehireEmployees().update(this.employeeUid, this.prepareFormData())
          .then(res => {
            if (res.status >= 200 && res.status < 300) {
              this.$emit('updated')
              this.$snack({ message: 'Employee details updated' }) 
              this.$refs.workday.loadingFalse()

              // this.dialog = false
            }
          })
          .catch(() => {
            this.$snack({ 
              message: 'Error! Please contact IT support',
              color: 'error',
            }) 
          })
          .then(() => {
            this.$refs.workday.loadingFalse()
          })
      },

      prepareFormData () {
        let employmentDetailData = this.$refs.employmentDetail.getFormData()
        let workdayData = this.$refs.workday.getFormData()

        return {
          city_id: employmentDetailData.city_id,
          confirmed_date: null, // not applicable once rehired
          last_working_date: null, // not applicable once rehired
          department_id: employmentDetailData.department_id,
          joined_date: employmentDetailData.joined_date,
          position_id: employmentDetailData.position_id,
          probation_period: employmentDetailData.probation_period,
          section_id: employmentDetailData.section_id,
          state_id: employmentDetailData.state_id,
          superior_id: employmentDetailData.superior_id,
          workdays: workdayData,
        }
      },
    },
  }
</script>
